import { GetSocial } from "../models/GetSocial"
import { Users } from "../models/Users"
import { UserProfilePayload } from "../models/UserProfilePayload"
import { UserProfile } from "../models/UserProfile"
import { EmailSignIn } from "../models/alt-EmailSignIn"
import { FacebookSignIn } from "../models/alt-FacebookSignIn"
import { GoogleSignIn } from "../models/alt-GoogleSignIn"
import { DeviceCodeSignIn } from "../models/alt-DeviceCodeSignIn"
import { AppleSignIn } from "../models/alt-AppleSignIn"
import { LoginResponse } from "../models/LoginResponse"
import { EmailSignUp } from "../models/alt-EmailSignUp"
import { DeviceCodeSignUp } from "../models/alt-DeviceCodeSignUp"
import { ResetPassSchema } from "../models/ResetPassSchema"
import { UpdateUserPayload } from "../models/UpdateUserPayload"
import { UpdatePassSchema } from "../models/UpdatePassSchema"
import { baseUrl, baseUrlV2, headers, headersV2 } from "./config"
import { appendFormData, fetchAndParse } from "./utils"
import { ActiveUsersCount } from "../models/ActiveUsersCount"
import {
  AdminUserSchedule,
  RescheduleMissedWorkoutsResponse,
  UserScheduledWorkoutsResponse,
} from "../models/UserScheduledWorkout"
export function getApiUserGetsocialtoken(): Promise<GetSocial> {
  const url = new URL(`/api/user/getsocial-token`, baseUrl)
  return fetchAndParse<GetSocial>(url.toString(), { method: "GET", headers })
}
export function getApiUserList(params?: {
  skip?: number
  limit?: number
  search?: string
  sortBy?: string
  sortOrder?: "asc" | "desc"
}): Promise<Users> {
  const url = new URL(`/api/user/list`, baseUrl)
  if (params) {
    const { skip, limit, search, sortBy, sortOrder } = params
    if (typeof skip === "number") url.searchParams.set("skip", String(skip))
    if (typeof limit === "number") url.searchParams.set("limit", String(limit))
    if (typeof search === "string" && search.trim().length > 0)
      url.searchParams.set("search", search.trim())
    if (typeof sortBy === "string" && sortBy.trim().length > 0)
      url.searchParams.set("sortBy", sortBy.trim())
    if (sortOrder === "asc" || sortOrder === "desc")
      url.searchParams.set("sortOrder", sortOrder)
  }
  return fetchAndParse<Users>(url.toString(), { method: "GET", headers })
}
export function getApiUserUserid(userId: number): Promise<UserProfilePayload> {
  const url = new URL(`/api/user/${userId}`, baseUrl)
  return fetchAndParse<UserProfilePayload>(url.toString(), {
    method: "GET",
    headers,
  })
}
export function getApiUserMeProfile(): Promise<UserProfilePayload> {
  const url = new URL(`/api/user/me/profile`, baseUrl)
  return fetchAndParse<UserProfilePayload>(url.toString(), {
    method: "GET",
    headers,
  })
}
export function putApiUserMeProfile(
  body?: UserProfile
): Promise<UserProfilePayload> {
  const url = new URL(`/api/user/me/profile`, baseUrl)
  return fetchAndParse<UserProfilePayload>(url.toString(), {
    method: "PUT",
    body: JSON.stringify(body),
    headers,
  })
}
export function getApiUserUnsubscribeEmailToken(
  token: string
): Promise<string> {
  const url = new URL(`/api/user/unsubscribe/email/${token}`, baseUrl)
  return fetchAndParse<string>(url.toString(), { method: "GET", headers })
}
export function postApiUserLogin(
  body?:
    | EmailSignIn
    | FacebookSignIn
    | GoogleSignIn
    | DeviceCodeSignIn
    | AppleSignIn
): Promise<LoginResponse> {
  const url = new URL(`/api/user/login`, baseUrl)
  return fetchAndParse<LoginResponse>(url.toString(), {
    method: "POST",
    body: JSON.stringify(body),
    headers,
  })
}
export function postApiUserRegister(
  body?: EmailSignUp | DeviceCodeSignUp
): Promise<number> {
  const url = new URL(`/api/user/register`, baseUrl)
  return fetchAndParse<number>(url.toString(), {
    method: "POST",
    body: JSON.stringify(body),
    headers,
  })
}
export function postApiUserResetpassword(
  body?: ResetPassSchema
): Promise<number> {
  const url = new URL(`/api/user/reset-password`, baseUrl)
  return fetchAndParse<number>(url.toString(), {
    method: "POST",
    body: JSON.stringify(body),
    headers,
  })
}
export function postApiUserUpdate(body?: UpdateUserPayload): Promise<string> {
  const url = new URL(`/api/user/update`, baseUrl)
  return fetchAndParse<string>(url.toString(), {
    method: "POST",
    body: JSON.stringify(body),
    headers,
  })
}
export function postApiUserUpdatepassword(
  body?: UpdatePassSchema
): Promise<number> {
  const url = new URL(`/api/user/update-password`, baseUrl)
  return fetchAndParse<number>(url.toString(), {
    method: "POST",
    body: JSON.stringify(body),
    headers,
  })
}
export function putApiUsersUserid(userId: number): Promise<number> {
  const url = new URL(`/api/users/${userId}`, baseUrl)
  return fetchAndParse<number>(url.toString(), {
    method: "PUT",
    body: null,
    headers,
  })
}
export function putApiUserMeProfilepicture(picture: File): Promise<string> {
  const localHeaders = { ...headers }
  delete localHeaders["Content-Type"]
  const data = new FormData()
  appendFormData(data, "picture", picture)
  const url = new URL(`/api/user/me/profile-picture`, baseUrl)
  return fetchAndParse<string>(url.toString(), {
    method: "PUT",
    body: data,
    headers: localHeaders,
  })
}
export function putApiUserMeUpdate(
  body?: UserProfilePayload
): Promise<UserProfilePayload> {
  const url = new URL(`/api/user/me/update`, baseUrl)
  return fetchAndParse<UserProfilePayload>(url.toString(), {
    method: "PUT",
    body: JSON.stringify(body),
    headers,
  })
}

export function getActiveUsersNo(): Promise<ActiveUsersCount> {
  const url = new URL(`/user/active-users/admin`, baseUrlV2)

  return fetchAndParse<ActiveUsersCount>(url.toString(), {
    method: "GET",
    headers: headersV2,
  })
}

export function putApiUsersLicenceExpiration(
  userId: number,
  licenceExpiration: string
): Promise<unknown> {
  const url = new URL(`/adapty/users/${userId}/licence-expiration`, baseUrlV2)
  return fetchAndParse(url.toString(), {
    method: "PUT",
    body: JSON.stringify({ licenceExpiration }),
    headers: headersV2,
  })
}

export function getUserScheduledWorkouts(
  userId: number
): Promise<UserScheduledWorkoutsResponse> {
  const url = new URL(`/user/${userId}/scheduled-workouts`, baseUrlV2)
  return fetchAndParse<UserScheduledWorkoutsResponse>(url.toString(), {
    method: "GET",
    headers: headersV2,
  })
}

export function postUserRescheduleMissedWorkouts(
  userId: number
): Promise<RescheduleMissedWorkoutsResponse> {
  const url = new URL(`/user/${userId}/reschedule-missed-workouts`, baseUrlV2)
  return fetchAndParse<RescheduleMissedWorkoutsResponse>(url.toString(), {
    method: "POST",
    headers: headersV2,
  })
}

export function getUserScheduleForAdmin(
  userId: number,
  scheduleId: number
): Promise<AdminUserSchedule> {
  const url = new URL(`/user/${userId}/schedules/${scheduleId}`, baseUrlV2)
  return fetchAndParse<AdminUserSchedule>(url.toString(), {
    method: "GET",
    headers: headersV2,
  })
}

export function putUserScheduleForAdmin(
  userId: number,
  scheduleId: number,
  body: {
    settings: {
      workoutDays: string[]
      startDate: string
      nrOfWeeks?: number
    }
  }
): Promise<unknown> {
  const url = new URL(`/user/${userId}/schedules/${scheduleId}`, baseUrlV2)
  return fetchAndParse(url.toString(), {
    method: "PUT",
    body: JSON.stringify(body),
    headers: headersV2,
  })
}

export function deleteUserScheduleForAdmin(
  userId: number,
  scheduleId: number
): Promise<{ success: boolean }> {
  const url = new URL(`/user/${userId}/schedules/${scheduleId}`, baseUrlV2)
  return fetchAndParse<{ success: boolean }>(url.toString(), {
    method: "DELETE",
    headers: headersV2,
  })
}
